"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeputyRole = exports.WorkforceIntegrationAction = void 0;
var WorkforceIntegrationAction;
(function (WorkforceIntegrationAction) {
    WorkforceIntegrationAction["USER_SYNC"] = "USER_SYNC";
    WorkforceIntegrationAction["DEPUTY_DEPUTY_USER_CREATE"] = "DEPUTY_DEPUTY_USER_CREATE";
    WorkforceIntegrationAction["DEPUTY_TILLX_USER_CREATE"] = "DEPUTY_TILLX_USER_CREATE";
})(WorkforceIntegrationAction = exports.WorkforceIntegrationAction || (exports.WorkforceIntegrationAction = {}));
var DeputyRole;
(function (DeputyRole) {
    DeputyRole["SUPERVISOR"] = "supervisor";
    DeputyRole["LOCATION_MANAGER"] = "location manager";
    DeputyRole["SYSTEM_ADMINISTRATOR"] = "system administrator";
    DeputyRole["EMPLOYEE"] = "employee";
})(DeputyRole = exports.DeputyRole || (exports.DeputyRole = {}));
//# sourceMappingURL=workforceIntegrations.js.map